import React from 'react';
import styled from 'styled-components';
import { SnackbarProvider as UnwrappedSnackbarProvider, MaterialDesignContent } from 'notistack';

const StyledMaterialDesignContent = styled(MaterialDesignContent)(() => ({
  '&.notistack-MuiContent': {
    fontSize: '14px',
    backgroundColor: '#000000E3'
  },
  '&.notistack-MuiContent-info': {
    backgroundColor: '#000000E3'
  },
  '&.notistack-MuiContent-success': {
    backgroundColor: '#226453'
  },
  '&.notistack-MuiContent-error': {
    backgroundColor: '#A72A2A'
  }
}));

interface Props {
    children: React.ReactNode;
}

const SnackbarProvider = ({ children }: Props) => {
  return (
    <UnwrappedSnackbarProvider
      maxSnack={5}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right'
      }}
      Components={{
        success: StyledMaterialDesignContent,
        error: StyledMaterialDesignContent,
        info: StyledMaterialDesignContent
      }}
    >
      {children}
    </UnwrappedSnackbarProvider>
  );
};
export default SnackbarProvider;
